import { isEqual } from 'lodash';

const selectorStateComparison = (formerState, currentState) => isEqual(formerState, currentState);

export default selectorStateComparison;
